import React, { useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import CreateEditViewPaymentIn from "../../../components/sales-section/sales-payment-in/create-edit-view-payment-in";
import { useDispatch } from "react-redux";
import { paymentInViewAction } from "../../../redux/actions/sales-action";
import { useParams } from "react-router-dom";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";

const EditPaymentIn = () => {
  const { id } = useParams();
  const [orderDetail, setOrderDetail] = useState({});
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(paymentInViewAction(id, onSuccPur, onErrPur));
  }, []);

  const onSuccPur = (data) => {
    setOrderDetail(data?.data);
    setLoading(false);
  };

  const onErrPur = (data) => {
    setLoading(false);
  };

  return (
    <InnerLayout backBtn={true} title="edit Payment In">
      {loading ? (
        <LoadingSpinner />
      ) : (
        <CreateEditViewPaymentIn
          disabled={true}
          data={orderDetail}
          page="Edit"
        />
      )}
    </InnerLayout>
  );
};

export default EditPaymentIn;
